import { apiGateway, api } from "../config";
import {AxiosPromise} from "axios";
import {IStocksExportSettings} from "../../constants/StocksExport/IStocksExportSettings";
import {IProductsRequest} from "./sellerProductsService";

class stocksExportService {

    async manuallyExport<T>(sellerId: number, isExportAllProducts: boolean, products: number[]) {
        return api(`${apiGateway.stocksExport}/manual-export-stocks-to-warehouses`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify({
                sellerID: sellerId,
                isExportAllProducts: isExportAllProducts,
                products: products
            })
        })
    }

    async manuallyRecalcAndExport<T>(sellerId: number, isFullExport:boolean,  isFilterBasedExport:boolean, isAllProducts: boolean, products: number[]) {
        return api(`${apiGateway.stocksExport}/recalc-distributed-stocks-to-warehouses`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify({
                sellerID: sellerId,
                isAllProducts: isAllProducts,
                products: products,
                isRunExport: true,
                isFullExport: isFullExport,
                isFilterBasedExport: isFilterBasedExport,
            })
        })
    }

    async saveSettings<T>(data: IStocksExportSettings, isFullExport:boolean) {
        return api(`${apiGateway.stocksExport}/setting/${data.uuid}?isFullExport=${isFullExport ? 'true' : 'false'}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    getSettingsForSeller<T>(sellerId: number): AxiosPromise {
        return api(`${apiGateway.stocksExport}/setting?sellerID=${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            }
        })
    }

    getDistributedStocksForSeller<T>(data: IProductsRequest): AxiosPromise {
        return api(`${apiGateway.stocksExport}/distributed-stocks`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    getIdsByFilter(sellerID: number, filter?: object): AxiosPromise {
        return api(`${apiGateway.stocksExport}/ids-by-filter`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: { sellerID, filter },
        })
    }
}

export default new stocksExportService();